import React, {useState} from 'react'
import TextField from '@material-ui/core/TextField'
import EditorSection from './EditorSection'
import TitleEditor from './TitleEditor'

export const editorSections = {
    hazards: "Hazards",
    cl: "Critical limits",
    monitoring_what : "Monitoring What",
    monitoring_how : "Monitoring How",
    monitoring_when : "Monitoring When",
    monitoring_who : "Monitoring Who",
    corrective_actions : "Corrective Actions",
    verification : "Verification",
    records : "Records",
}

export default function({
    handleFormChange, 
    setActiveSection, 
    setUploadOpen,
    sopState,
    setSopState,
    attachments,
    children, 
}){

    const { 
        hazards,
        cl,
        monitoring_what,
        monitoring_how,
        monitoring_when,
        monitoring_who,
        corrective_actions,
        verification,
        records,
    } = { ... attachments?.attachments?.ccp }
    
    const handleOnClick = (section) => {
        setActiveSection(section)
        setUploadOpen(true)
    }
    
    const handleOnUpdate = (section, val) => {
        setSopState({...sopState, [section]: val})
    }

    let masterDoc = sopState["masterDoc"]?sopState["masterDoc"]:"";
    let typeOfDoc = sopState["typeOfDoc"]?sopState["typeOfDoc"]:"";
    let documentKey = sopState["documentKey"]?sopState["documentKey"]:"";
    let name = sopState["name"]?sopState["name"]:"";
    let title=masterDoc+"-"+typeOfDoc+"-"+documentKey+" "+name;

    return (
        <div>
            <h2>Critical Control Point Editor</h2>
            <form noValidate autoComplete="off">
                <div>
                    <TitleEditor  id="titleEditor"
                     handleFormChange={handleFormChange}
                     setActiveSection={setActiveSection}
                     setUploadOpen={setUploadOpen}
                     sopState={sopState}
                     setSopState={setSopState}
                    />
                </div>
                <div>
                    <TextField id="title" label="Critical Control Point" value={title} 
                    onChange={(e) => handleFormChange(e)} 
                    style={{width:'80%', marginBottom:20}}
                    />
                </div>
                <EditorSection 
                    sectionName={editorSections.hazards}
                    onClick={ () => { handleOnClick('hazards')}}
                    html={sopState?.hazards}
                    onUpdate={ (val) => { handleOnUpdate('hazards', val) }}
                    attachment={hazards}
                />
                <EditorSection 
                    sectionName="Critical limits"
                    onClick={ () => { handleOnClick('cl')}}
                    html={sopState?.cl}
                    onUpdate={ (val) => { handleOnUpdate('cl', val) }}
                    attachment={cl}
                />
                <EditorSection 
                    sectionName="Monitoring - What"
                    onClick={ () => { handleOnClick('monitoring_what')}}
                    html={sopState?.monitoring_what}
                    onUpdate={ (val) => { handleOnUpdate('monitoring_what', val) }}
                    attachment={monitoring_what}
                />
                <EditorSection 
                    sectionName="Monitoring - How"
                    onClick={ () => { handleOnClick('monitoring_how')}}
                    html={sopState?.monitoring_how}
                    onUpdate={ (val) => { handleOnUpdate('monitoring_how', val) }}
                    attachment={monitoring_how}
                />
                <EditorSection 
                    sectionName="Monitoring - When"
                    onClick={ () => { handleOnClick('monitoring_when')}}
                    html={sopState?.monitoring_when}
                    onUpdate={ (val) => { handleOnUpdate('monitoring_when', val) }}
                    attachment={monitoring_when}
                />
                <EditorSection 
                    sectionName="Monitoring - Who"
                    onClick={ () => { handleOnClick('monitoring_who')}}
                    html={sopState?.monitoring_who}
                    onUpdate={ (val) => { handleOnUpdate('monitoring_who', val) }}
                    attachment={monitoring_who}
                />
                <EditorSection 
                    sectionName="Corrective actions"
                    onClick={ () => { handleOnClick('corrective_actions')}}
                    html={sopState?.corrective_actions}
                    onUpdate={ (val) => { handleOnUpdate('corrective_actions', val) }}
                    attachment={corrective_actions}
                />
                <EditorSection 
                    sectionName="Verification"
                    onClick={ () => { handleOnClick('verification')}}
                    html={sopState?.verification}
                    onUpdate={ (val) => { handleOnUpdate('verification', val) }}
                    attachment={verification}
                />
                <EditorSection 
                    sectionName="Records"
                    onClick={ () => { handleOnClick('records')}}
                    html={sopState?.records}
                    onUpdate={ (val) => { handleOnUpdate('records', val) }}
                    attachment={records}
                />
                {children}
            </form>
        </div>
    )
}